import { Button } from "@/components/ui/button"
import { FormField } from "@/components/ui/form-field"
import { Input } from "@/components/ui/input"
import { SheetPageBody, SheetPageTitle } from "@/components/ui/sheet-page"
import { VALIDATION_ERROR_KEYS } from "@/i18n"
import { LayoutTemplate } from "lucide-react"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { useNavigate, usePathParam } from "@/lib/page-rendering"

export default function Page() {
  const navigate = useNavigate()
  const { t } = useTranslation(["preference_templates", "common"])
  const schoolId = usePathParam("schoolId")
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<{ template: { name: string } }>()
  const submitHandler = (data: { template: { name: string } }) => {
    navigate({
      href: `/learners/schools/${schoolId}/preference_templates`,
      method: "post",
      data: { template: { name: data.template.name, school_id: schoolId } },
    }).then(({ errors }) => {
      if (Object.keys(errors).length === 0) {
        window.parent.postMessage("sheet:reload_on_close")
        window.parent.postMessage("sheet:close")
      }
    })
  }

  return (
    <SheetPageBody className="space-y-3">
      <SheetPageTitle icon={LayoutTemplate}>{t("new.title")}</SheetPageTitle>
      <form onSubmit={handleSubmit(submitHandler)} className="space-y-3">
        <FormField
          {...register("template.name", {
            required: t(VALIDATION_ERROR_KEYS.REQUIRED),
          })}
          className="space-y-2"
          errors={errors}
          label={t("new.form.name")}
        >
          <Input />
        </FormField>
        <Button type="submit" className="w-full">
          {t("new.save")}
        </Button>
      </form>
    </SheetPageBody>
  )
}
